module.exports = __webpack_public_path__ + "img/illustrations.6a28011f.png";